import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MainApp from "./components/Admin/Main/Main";
import "./App.scss";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { appService } from "./app.service";
import "core-js/features/array/includes";
import "core-js/features/array/find";
import "core-js/features/array/find-index";
import "core-js/features/object/get-prototype-of";
import { Spinner } from "reactstrap";
export const history = createBrowserHistory();
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            role: null,
            error: null,
            userDetails: null,
            isLoading: true
        };
    }
    loadPage = () => {
        window.addEventListener("load", () => {
            this.setState({ isLoading: true });
        });
    };

    componentDidMount() {
        this.getPermissions();
    }

    getPermissions = () => {
        appService
            .getPermissions()
            .then(response => {
                response &&
                    this.setState({
                        authority: response[0].authority
                    });

                if (response[0].authority === "ROLE_VLA_INSTRUCTOR") {
                    this.setState({
                        role: "ROLE_VLA_INSTRUCTOR",
                        isLoading: false
                    });
                } else if (response[0].authority === "ROLE_VLA_ADMIN") {
                    this.setState({
                        role: "ROLE_VLA_ADMIN",
                        isLoading: false
                    });
                }
            })
            .catch(error => this.setState({ error: error }));
    };

    getUser = () => {
        appService
            .getUser()
            .then(response => response && this.setState({ userDetails: response }))
            .catch(error => this.setState({ error: error }));
    };

    render() {
        const { role, isLoading } = this.state;

        return (
            <Router history={history}>
                <div className="App">
                    <ToastContainer />
                    {isLoading && (
                        <Spinner
                            color="success"
                            style={{
                                position: "absolute",
                                marginTop: "15rem",
                                marginLeft: "55em",
                                zIndex: 1,
                                width: "3rem",
                                height: "3rem"
                            }}
                        />
                    )}
                    
                    <MainApp role={role} />
                </div>
            </Router>
        );
    }
}

export default App;
